/* oxlint-disable no-inner-declarations */
import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import type { TaskDetails } from '@/task-manager/entities/task-details';
import type { TaskFile } from '@/task-manager/entities/task-file';
import { Optimistic } from '@/utils/react-query/optimistic';

import { type BodyOf, tasksV1CardsFilesDeleteDestroy } from '../fetch-client';
import { ListTaskFiles } from '../queries/list-task-files';
import { useFetchOpts } from '../use-fetch-opts';

export namespace DeleteTaskFile {
  export type Input = { task: TaskDetails; file: TaskFile };
  export type Output = void;

  function bodyFromInput(
    input: Input,
  ): BodyOf<typeof tasksV1CardsFilesDeleteDestroy> {
    return {
      uuid: input.task.id,
      fileId: input.file.id,
    };
  }

  export function useMutation() {
    const getOpts = useFetchOpts();
    const queryClient = rq.useQueryClient();

    return rq.useMutation<Output, unknown, Input>({
      async mutationFn(input) {
        const opts = await getOpts();
        const body = bodyFromInput(input);
        await ok(tasksV1CardsFilesDeleteDestroy(body, opts));
        return;
      },
      onMutate(input) {
        queryClient.cancelQueries(ListTaskFiles.key(input.task));
        queryClient.setQueryData(
          ListTaskFiles.key(input.task),
          ListTaskFiles.optimistic((previous) => ({
            ...previous,
            files: Optimistic.deleteItem(
              previous.files,
              ({ id }) => id === input.file.id,
            ),
          })),
        );
      },
      async onSettled(_, __, { task }) {
        await queryClient.invalidateQueries({
          queryKey: ListTaskFiles.key(task),
        });
      },
    });
  }
}
